<template xmlns="http://www.w3.org/1999/html">
    <div class="container mt-3">

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                            <label>Ваш основной Email адрес</label>
                                <input type="text" class="form-control" v-model="merchant.email" readonly disabled>
                            </div>
                            <div class="form-group">
                                <label>Добавить Email адреса</label>
                            </div>
                            <div class="form-group" v-for="(email, key) in emails" :key="key">
                                <label class="fa fa-envelope" style="color: #8a689e"></label>
                                <input type="text" class="form-control" v-model="emails[key]">
                                <i class="fa fa-minus-circle" style="color: #8a689e" v-on:click="inputDelete(key)"></i>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Ваши сохраненные Email адреса</label>
                            </div>
                            <div class="form-group" v-for="email in merchantEmails" :key="email.id">
                                <input type="text" class="form-control" :class="isEmailValid" v-model="email.email" readonly disabled>
                                <i class="fa fa-minus-circle" style="color: #8a689e" v-on:click="removeEmails(email.id)"></i>
                            </div>
                        </div>
                        </div>
                        <div class="col-md-12">
                            <button class="btn btn-primary" v-on:click="updateEmails">Сохранить</button>
                            <button class="btn btn-primary" v-on:click="addNew">Добавить</button>
                            <p v-if="error" v-text="error" style="color: red"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "SettingsEmail",
        created() {
            this.getEmails();
        },
        data() {
            return {
                error: '',
                emails: [''],
                merchantEmails: [],
            }
        },
        methods: {
            addNew() {
                this.emails.push('')
            },
            inputDelete(i) {
                this.emails.splice(i, 1)
            },
            getEmails() {
                axios.get('/admin/ajax/merchant-emails').then(response => {
                    this.merchantEmails = response.data;
                })
            },
            updateEmails() {
                axios.post('/admin/ajax/merchant-emails', { emails: this.emails})
                    .then(response =>{
                        this.getEmails();
                        this.error = '';
                }).catch(error => {
                    this.error = error.response.data.message;
                });
                return this.emails = [''];
            },
            removeEmails(emailId) {
              axios.delete('/admin/ajax/merchant-emails/' + emailId)
                  .then(response =>{
                      this.getEmails()
              }).catch(error => {
                  alert('System Error');
              });
            },
        },
        computed: {
            ...mapState ({
                merchant: state => state.merchant,
            })
        },
    }
</script>

<style scoped>
    input {
        display: inline-block;
        width: 70%;
    }
</style>